import { createRouter, createWebHistory } from "vue-router";

const Store = () => import("../pages/Store.vue");
const Loading = () => import("../pages/Loading.vue");
const Home = () => import("../pages/Home.vue");
const Privacy = () => import("../pages/Privacy.vue");
const Term = () => import("../pages/Term.vue");

const routes = [
  { path: "/", name: "Store", component: Store },
  { path: "/loading", name: "Loading", component: Loading },
  { path: "/home", name: "Home", component: Home },
  { path: "/privacy", name: "Privacy", component: Privacy },
    { path: "/terms", name: "Term", component: Term },
     { path: '/random', component: Loading }, 
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
